import { LoginBackground } from "@/assets/images/login-background";
import { SignUpForm } from "@/components/pages/signup/signup-form";

export const SignUpPage = () => {
  return (
    <div className="relative min-h-screen flex items-center justify-center p-4">
      <LoginBackground />
      <div className="z-10 w-full max-w-4xl">
        <SignUpForm />
      </div>
    </div>
  );
};
